// import { ipcRenderer } from 'electron'
// import isElectron from 'is-electron'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { readAsText } from 'promise-file-reader'
import compareVersions from "compare-versions"

import resourceURLs from '../constants/deviceResourcePaths'
import tooltips from '../constants/tooltips.json'

import { asyncFetchJSON, getDuplicates } from '../utilities'

import PresetManagerSelect from './PresetManagerSelect'
import PresetManagerUser from './PresetManagerUser'
import PresetManagerUserDialog from './PresetManagerUserDialog'

import {
  addPreset,
  setAvailableFirmware,
  setAvailableEditor,
  setUpdateableEditor,
  setUpdatesAvailable,
  openPresetRenamer,
  setTempImportedPresets,
} from "../actions/";

class PresetManager extends Component {
  componentDidMount() {
    // if(isElectron()) ipcRenderer.on('preset-import', (event, presets) => this.props.onAddPresets('user', presets))

    const betaType = this.props.isBeta

    if(navigator.onLine) {
      // get currentVersions of editor and firmware
      let firmwareVersionPath = (betaType) ? 'firmwareCurrentVersionBetas' : 'firmwareCurrentVersion'
      let editorVersionPath = (betaType) ? 'editorCurrentVersionBetas' : 'editorCurrentVersion'
      let factoryPresetsPath = (betaType) ? 'factoryPresetsBeta' : 'factoryPresets'

      try {
        Promise.all([
          asyncFetchJSON(resourceURLs[firmwareVersionPath]),
          asyncFetchJSON(resourceURLs[editorVersionPath]),
          asyncFetchJSON(resourceURLs[factoryPresetsPath])
        ]).then(versions => {
          const [availableFirmware, availableEditor, factoryPresets] = versions

          if(versions.some(v => v === false)) {
              // send message or status
              console.log('>> malletSTATION Editor: network issue, could not fetch resources')
          } else {
            this.props.onSetAvailableFirmware((betaType) ? availableFirmware[betaType] : availableFirmware)
            this.props.onSetAvailableEditor((betaType) ? availableEditor[betaType] : availableEditor)
            // set update editor available flag
            this.props.onSetUpdateableEditor(
              compareVersions(
                betaType
                  ? availableEditor[betaType]?.version
                  : availableEditor.version,
                this.props.editorVersion
              )
            );
            this.props.onAddPresets('factory', factoryPresets)
          }
        })
      } catch (e) {
        console.log('>> malletSTATION Editor: resource fetching error', e)
      }
    }
  }

  componentWillUnmount() {
    // if(isElectron()) ipcRenderer.removeAllListeners('preset-import')
    // cancel server resource calls
  }

  onDrop = (acceptedFiles, rejectedFiles, onAddPresets, presetsUser) => {
    const {
      onOpenPresetRenamer,
      onSetTempImportedPresets
    } = this.props

    acceptedFiles.forEach(file => {
      readAsText(file)
        .then(presetsAsString => {
          const importedPresets = JSON.parse(presetsAsString),
                duplicateNames = getDuplicates(presetsUser, importedPresets)

          if(Object.keys(duplicateNames).length) {
            console.log('>> User Preset Names already exist', Object.values(duplicateNames).join(', '));
            onSetTempImportedPresets(importedPresets, duplicateNames)
            onOpenPresetRenamer();
          } else {
            console.log('>> Importing User Presets:', importedPresets.map(p => p.name).join(', '))
            onAddPresets('user', importedPresets)
          }
        })
        .catch(err => console.warn('>> Could not import presets', err))
    });
  }

  render() {
    const {
      presetsUser,
      userPresetDialogOpen,
      showTooltips,
      onAddPresets,
      onOpenPresetRenamer
    } = this.props

    return (
      <Dropzone
        className='preset-manager-drop'
        style={{}}
        activeClassName='active-drop'
        acceptClassName='accept-file-drop'
        rejectClassName='reject-file-drop'
        disableClick={true}
        accept='application/json'
        onDrop={(accepted, rejected) => this.onDrop(accepted, rejected, onAddPresets, presetsUser, onOpenPresetRenamer)}
        >
        <div
          className="preset-manager"
          data-tip={tooltips['preset-manager']}
          data-multiline="true"
          data-tip-disable={!showTooltips}
        >
          <PresetManagerSelect />
          {(userPresetDialogOpen) ? <PresetManagerUserDialog /> : <PresetManagerUser /> }
        </div>
      </Dropzone>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isBeta: state.editor.beta,
    deviceFirmwareVersion: state.device.firmwareVersion,
    userPresetDialogOpen: state.editor.userPresetDialogOpen,
    presetsImportRenameDialogOpen: state.editor.presetsImportRenameDialogOpen,
    networkConnection: state.editor.networkConnection,
    editorVersion: state.editor.editorVersion,
    showTooltips: state.editorPreferences.showTooltips,
    presetsUser: state.presets.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddPresets: (category, presets) => {
      presets.forEach((preset) => dispatch(addPreset(category, preset)));
    },
    onSetAvailableFirmware: (version) => {
      dispatch(setAvailableFirmware(version));
    },
    onSetAvailableEditor: (version) => {
      dispatch(setAvailableEditor(version));
    },
    onSetUpdateableEditor: (updateable) => {
      dispatch(setUpdateableEditor(updateable));
    },
    onSetUpdatesAvailable: () => {
      dispatch(setUpdatesAvailable());
    },
    onSetTempImportedPresets: (importedPresets, duplicateNames) => {
      dispatch(setTempImportedPresets(importedPresets, duplicateNames));
    },
    onOpenPresetRenamer: () => {
      dispatch(openPresetRenamer());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetManager)
